import React from 'react';

function FilterControls({ activeFilter, onFilterChange, searchRadius, onRadiusChange }) {
  const filters = [
    { key: 'all', label: 'All' },
    { key: 'now', label: 'Available Now' },
    { key: 'scheduled', label: 'Scheduled' },
    { key: 'clubs', label: 'Clubs & Recurring' },
  ];

  const radii = [
    { value: 5, label: '5 mi' },
    { value: 15, label: '15 mi' },
    { value: 50, label: '50 mi' },
    { value: 10000, label: 'Any' },
  ];

  return (
    <div className="flex flex-col sm:flex-row justify-center items-center gap-4 mb-4">
      <div className="w-full flex justify-center">
        <div className="flex bg-gray-200 rounded-lg p-1 overflow-x-auto max-w-full webkit-scrollbar-hide">
          {filters.map((filter) => (
            <button
              key={filter.key}
              onClick={() => onFilterChange(filter.key)}
              className={`px-3 py-1 text-sm font-semibold rounded-md transition-colors duration-200 whitespace-nowrap ${activeFilter === filter.key
                  ? 'bg-indigo-600 text-white shadow'
                  : 'text-gray-700 hover:bg-gray-300'
                }`}
            >
              {filter.label}
            </button>
          ))}
        </div>
      </div>

      {searchRadius !== undefined && onRadiusChange && (
        <div className="w-full flex justify-center">
          <div className="flex bg-gray-200 rounded-lg p-1 overflow-x-auto max-w-full webkit-scrollbar-hide">
            {radii.map((r) => (
              <button
                key={r.value}
                onClick={() => onRadiusChange(r.value)}
                className={`px-3 py-1 text-[13px] sm:text-sm font-semibold rounded-md transition-colors duration-200 ${searchRadius === r.value
                    ? 'bg-indigo-600 text-white shadow'
                    : 'text-gray-700 hover:bg-gray-300'
                  }`}
              >
                {r.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default FilterControls;